import React, { useState, useEffect,useRef } from 'react';
import { setTitle } from "../../helpers/MetaTag";
import Button from "../../components/form/Button";
import Select from '../../components/form/Select';
import Input from "../../components/form/Input";
import Textarea from '../../components/form/Textarea';
import { Link } from "react-router-dom";
import { dayRemaining } from "../../helpers";
import toastr from "toastr";
import moment from "moment/moment";
import { postData } from "../../services/api";
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';

import { useTranslation } from "react-i18next";

const LeadTracking = () => {
  setTitle("Succession Planning Software for your Business with Succession Now | Sales team");
  const { i18n,t } = useTranslation();
  const flatPicker = useRef(null);
  const [sizes, setSizes] = useState([]); 
  const [companyName, setCompanyName] = useState("");
  const [companyAdministrator, setCompanyAdministrator] = useState("");
  const [companyAdministratorEmail, setCompanyAdministratorEmail] = useState("");
  const [verifyCompanyAdministratorEmail, setVerifyCompanyAdministratorEmail] = useState("");
  const [companyAdministratorPhone, setCompanyAdministratorPhone] = useState("");
  const [companyLocation,setCompanyLocation] = useState("");
  const [companySize, setCompanySize] = useState("");
  const [referredBy, setReferredBy] = useState("");
  const [leadSource,setLeadSourcee] = useState('');
  const [contactDate, setContactDate] = useState("");
  const [firstResponseDate, setFirstResponseDate] = useState("");  
  const [responseType, setResponseType] = useState("");
  const [responder,setResponder] = useState("");
  const [firstResponseNotes,setFirstResponseNotes] = useState("");
  const [decision,setDecision] = useState("");
  const [demoDate,setDemoDate] = useState("");
  const [demoNotes,setDemoNotes] = useState("");
  const [demoCompletion,setDemoCompletion] = useState("");
  const [secondDemoDate,setSecondDemoDate] = useState("");
  const [secondDemoNotes,setSecondDemoNotes] = useState("");
  const [secondDemoCompletion,setSecondDemoCompletion] = useState("");
  const [status,setStatus] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);
  const [isCancel, setIsCancel] = useState(false);   

  const onCancel = async (e) => {
    setIsCancel(true);   
    setIsCancel(false);
  }; 

  const onUpdate = async (e) => {
    setIsUpdate(true);
    try {      
      const result = await postData("salesteam/lead-create", {
        company_name : companyName,
        primary_contact_name : companyAdministrator,
        primary_contact_email : companyAdministratorEmail,
        verify_company_adminstrator_email : verifyCompanyAdministratorEmail,
        company_location :companyLocation,
        primary_contact_phone : companyAdministratorPhone,
        company_size : companySize,
        referred_by : referredBy,
        lead_source : leadSource,
        contact_date : contactDate,
        first_response_date : firstResponseDate,               
        response_type : responseType,
        responder :responder, 
        first_response_notes : firstResponseNotes,
        decision : decision,
        demo_date : demoDate,
        demo_notes : demoNotes,
        demo_completion : demoCompletion,
        second_demo_date : secondDemoDate,
        second_demo_notes : secondDemoNotes,
        second_demo_completion : secondDemoCompletion,
        status : status
      });
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setCompanyName('');
        setCompanyAdministrator('');
        setCompanyAdministratorEmail('');
        setVerifyCompanyAdministratorEmail('');
        setCompanyLocation('')
        setCompanyAdministratorPhone('');
        setCompanySize('');
        setReferredBy('');
        setLeadSourcee('');
        setContactDate('');
        setFirstResponseDate(''); 
        setResponseType('');
        setResponder('');       
        setFirstResponseNotes('');   
        setDecision(''); 
        setDemoDate('');  
        setDemoNotes('');
        setDemoCompletion('');
        setSecondDemoDate('');
        setSecondDemoNotes('');
        setSecondDemoCompletion('');
        setStatus('')
        setIsUpdate(false);
      } else {
        toastr.error(result.message);
        setIsUpdate(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsUpdate(false);
    }
  };   

  useEffect(() => {
    // Plan list
    const loadCompanySize = async () => {
      try {
        const result = await postData("company-size/list", {
          sortQuery : {ordering:1}
        });
        if (result.data) {
          setSizes(result.data)
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadCompanySize();
  },[])

  return (
    <>
      {/* <div className="relative flex justify-between items-center mb-4">
        <div className="text-3xl text-slate-800 font-bold">Lead Tracking</div>
      </div> */}
      <div className="relative bg-white shadow rounded">
        <div className="py-10 px-1">
          <div className="relative space-y-10">   
            <Link to={'/'}>
              <div className="h-10 w-full flex justify-center object-contain mb-5">
                <svg className="h-full" preserveAspectRatio="xMidYMid meet" data-bbox="0 0 382.89 71.37" viewBox="0 0 382.89 71.37" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" aria-labelledby="svgcid-iz595q-x7t6i4"><title id="svgcid-iz595q-x7t6i4">SuccessionNow Logo</title><g><path d="m21.02 40.95-6.88-2.98c-3.78-1.61-4.59-3.29-4.59-6.01s1.05-5.15 5.08-5.15c3.41 0 4.84 2.42 4.84 6.57h8.56v-1.24c0-8.49-5.77-11.9-13.7-11.9-8.44 0-13.71 4.4-13.71 13.02 0 7.38 3.66 10.66 11.59 13.39 5.89 2.05 7.94 3.53 7.94 7.56 0 3.72-2.6 5.46-5.33 5.46-4.71 0-5.89-2.67-5.89-6.82v-1.3H0v1.8c0 8.18 3.97 12.9 14.07 12.9s15.38-4.22 15.38-13.58c0-5.39-1.74-8.8-8.43-11.72Z" fill="#3a8078" data-color="1"></path><path d="M49.45 54.15c0 3.72-1.61 5.52-4.53 5.52-2.54 0-3.66-1.3-3.66-4.65v-23H32.7v24.74c0 6.57 3.16 9.49 8.49 9.49 3.6 0 6.7-1.49 8.49-4.77h.12v3.91h8.18V32.02h-8.56v22.13Z" fill="#3a8078" data-color="1"></path><path d="M75.18 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M103.19 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M131.01 31.15c-11.53 0-13.27 8.31-13.27 17.24 0 8.31.5 17.85 12.9 17.85 8.06 0 11.78-4.34 12.09-12.09h-7.69c-.5 4.09-1.67 6.26-4.53 6.26-3.16 0-4.22-3.84-4.22-7.75v-2.67h16.92v-1.92c0-10.23-2.23-16.93-12.21-16.93Zm-4.71 13.76v-1.3c0-3.1.99-6.63 4.4-6.63s4.15 2.85 4.34 7.94h-8.74Z" fill="#3a8078" data-color="1"></path><path d="m162.72 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path d="m189.75 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path fill="#3a8078" d="M209.32 20.61v7.32h-8.56v-7.32h8.56z" data-color="1"></path><path fill="#3a8078" d="M209.32 32.02v33.35h-8.56V32.02h8.56z" data-color="1"></path><path d="M226.36 31.15c-9.8 0-13.14 6.14-13.14 17.54s2.85 17.73 13.14 17.55c9.8 0 13.14-6.14 13.14-17.55s-2.85-17.73-13.14-17.54Zm0 29.26c-4.22 0-4.59-4.9-4.59-11.72s.37-11.72 4.59-11.72c3.47 0 4.59 3.41 4.59 11.72s-1.12 11.72-4.59 11.72Z" fill="#3a8078" data-color="1"></path><path d="M260 31.15c-3.6 0-6.7 1.49-8.49 4.77h-.12v-3.91h-8.18v33.35h8.56V43.23c0-3.72 1.61-5.52 4.53-5.52 2.54 0 3.66 1.3 3.66 4.65v23h8.56V40.62c0-6.57-3.16-9.49-8.49-9.49Z" fill="#3a8078" data-color="1"></path><path d="M325.74 31.15c-9.8 0-14.45 6.14-16.86 17.54-2.48 11.59-.93 17.73 9.42 17.55 9.79 0 14.45-6.14 16.86-17.55 2.48-11.59.93-17.73-9.42-17.54Zm.87 17.54c-1.74 8.31-3.6 11.72-7.07 11.72-4.21 0-3.53-4.9-2.11-11.72 1.49-6.82 2.85-11.72 7.07-11.72 3.47 0 3.91 3.41 2.11 11.72Z" fill="#a7a9ac" data-color="2"></path><path fill="#a7a9ac" d="m374.7 32.02-9.05 23.68h-.12l.62-23.68h-9.3l-9.18 23.68h-.12l1.11-23.68h-8.55l.18 33.35h9.92l9.18-23.68h.12l-.62 23.68h9.74l14.26-33.35h-8.19z" data-color="2"></path><path fill="#a7a9ac" d="M321.29 12.82 313.02 0 300.2 8.27l6.29 1.36-11.16 41.79h-.13l-5.34-23.31h-10.29l-9.42 43.26h8.18l6.57-29.99h.13l5.34 23.99h10.16l14.2-53.96 6.56 1.41z" data-color="2"></path></g></svg>
              </div>
            </Link>       
            <div className='mx-auto max-w-4xl space-y-4'>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500 leading-tight inline-flex">{t('company_name')}</div>
                </div>
                <div className="col-span-2">
                    <Input
                      inputType={"text"}
                      inputValue={companyName}
                      setInput={setCompanyName}
                      isDisabled={false}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('primary_contact_name')}</div>
                </div>
                <div className="col-span-2">
                    <Input
                      inputType={"text"}
                      inputValue={companyAdministrator}
                      setInput={setCompanyAdministrator}
                      isDisabled={false}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('primary_contact_email_address')}</div>
                </div>
                <div className="col-span-2">
                    <Input
                      inputType={"text"}
                      inputValue={companyAdministratorEmail}
                      setInput={setCompanyAdministratorEmail}
                      isDisabled={false}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('verify_primary_contact_email_address')}</div>
                </div>
                <div className="col-span-2">
                    <Input
                      inputType={"text"}
                      inputValue={verifyCompanyAdministratorEmail}
                      setInput={setVerifyCompanyAdministratorEmail}
                      isDisabled={false}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('company_location')}</div>
                </div>
                <div className="col-span-2">
                    <Input
                      inputType={"text"}
                      inputValue={companyLocation}
                      setInput={setCompanyLocation}
                      isDisabled={false}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('primary_contact_phone_number')}</div>
                </div>
                <div className="col-span-2">
                    <Input
                      inputType={"text"}
                      inputValue={companyAdministratorPhone}
                      setInput={setCompanyAdministratorPhone}
                      isDisabled={false}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('company_size')}</div>
                </div>
                <div className="col-span-2">
                    <Select
                      xPlacement={"left"}
                      selectedValue={companySize}
                      dropdownClass={"!w-60"}
                      dropdownButtonLabelClass={"!font-bold"}
                      dropdownData={[
                        { _id: "", label: t('select_size'), value: "" },
                        ...sizes.map((boardyear_item) => ({
                          _id: boardyear_item?._id,
                          label: boardyear_item?.name,
                          value: boardyear_item?._id,
                        })),
                      ]}
                      dropdownOptionBold={true}
                      getSelectedValue={(e) => setCompanySize(e._id)}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('referred_by')} ({t('if_applicable')})</div>
                </div>
                <div className="col-span-2">
                    <Input
                      inputType={"text"}
                      inputValue={referredBy}
                      setInput={setReferredBy}
                      isDisabled={false}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('lead_source')}</div>
                </div>
                <div className="col-span-2">
                    <Select
                      xPlacement={"left"}
                      selectedValue={leadSource}
                      dropdownClass={"!w-60"}
                      dropdownButtonLabelClass={"!font-bold"}
                      dropdownData={[
                        { _id: "", label: t('select_lead_source'), value: "" },
                        { _id: "linkedin", label: "LinkedIn", value: "linkedin" },
                        { _id: "subscriber-referral", label: "Subscriber Referral", value: "subscriber-referral" },
                        { _id: "gartner", label: "Gartner", value: "gartner" },
                        { _id: "google-ads", label: "Google Ads", value: "google-ads" },
                        { _id: "facebook", label: "Facebook", value: "facebook" },
                        { _id: "web-search", label: "Web Search", value: "web-search" },
                      ]}
                      dropdownOptionBold={true}
                      getSelectedValue={(e) => setLeadSourcee(e._id)}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('initial_contact_date')}</div>
                </div>
                <div className="col-span-2">
                  <Flatpickr
                    ref={flatPicker}
                    className='w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200'
                    placeholder={t('enter_date')}
                    value={contactDate}
                    options={{ 
                      dateFormat: "m/d/Y",
                      //minDate:new Date()
                    }}
                    onChange={(selectedDates, dateStr, instance) => {
                      setContactDate(dateStr)
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('first_response_date')}</div>
                </div>
                <div className="col-span-2">
                  <Flatpickr
                    ref={flatPicker}
                    className='w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200'
                    placeholder={t('enter_date')}
                    value={firstResponseDate}
                    options={{ 
                      dateFormat: "m/d/Y",
                      //minDate:new Date()
                    }}
                    onChange={(selectedDates, dateStr, instance) => {
                      setFirstResponseDate(dateStr)
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('response_type')}</div>
                </div>
                <div className="col-span-2">
                    <Select
                      xPlacement={"left"}
                      selectedValue={responseType}
                      dropdownClass={"!w-60"}
                      dropdownButtonLabelClass={"!font-bold"}
                      dropdownData={[
                        { _id: "", label: t('select_response_type'), value: "" },
                        { _id: 1, label: t('phone'), value: 1 },
                        { _id: 2, label: t('email'), value: 2 }
                      ]}
                      dropdownOptionBold={true}
                      getSelectedValue={(e) => setResponseType(e._id)}
                    />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('responder')}</div>
                </div>
                <div className="col-span-2">
                    <Input
                      inputType={"text"}
                      inputValue={responder}
                      setInput={setResponder}
                      isDisabled={false}
                    />
                </div>
              </div>              
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('first_response_notes')}</div>
                </div>
                <div className="col-span-2">
                  <Textarea
                    inputClasses={"!h-32"}
                    inputValue={firstResponseNotes}
                    setTextarea={setFirstResponseNotes}                  
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('decision')}</div>
                </div>
                <div className="col-span-2">
                    <Select
                      xPlacement={"left"}
                      selectedValue={decision}
                      dropdownClass={"!w-60"}
                      dropdownButtonLabelClass={"!font-bold"}
                      dropdownData={[
                        { _id: "", label: t('select_decision'), value: "" },
                        { _id: 1, label: t('demo_scheduled'), value: 1 },
                        { _id: 2, label: t('demo_declined'), value: 2 },
                        { _id: 3, label: t('no_response'), value: 3 }
                      ]}
                      dropdownOptionBold={true}
                      getSelectedValue={(e) => setDecision(e._id)}
                    />
                </div>
              </div>
              <div class="inline-flex items-center justify-center w-full">
                  <hr class="w-64 h-px my-8 bg-gray-200 border-0 dark:bg-gray-700"/>
                  <span class="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-gray-900">{t('first_demo')}</span>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('date')}</div>
                </div>
                <div className="col-span-2">
                  <Flatpickr
                    ref={flatPicker}
                    className='w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200'
                    placeholder={t('enter_date')}
                    value={demoDate}
                    options={{ 
                      dateFormat: "m/d/Y",
                      //minDate:new Date()
                    }}
                    onChange={(selectedDates, dateStr, instance) => {
                      setDemoDate(dateStr)
                    }}
                  />
                </div>
              </div>      
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('notes')}</div>
                </div>
                <div className="col-span-2">
                  <Textarea
                    inputClasses={"!h-32"}
                    inputValue={demoNotes}
                    setTextarea={setDemoNotes}                  
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('completion')}</div>
                </div>
                <div className="col-span-2">
                    <Select
                      xPlacement={"left"}
                      selectedValue={demoCompletion}
                      dropdownClass={"!w-60"}
                      dropdownButtonLabelClass={"!font-bold"}
                      dropdownData={[
                        { _id: "", label: t('select_completion'), value: "" },
                        { _id: 1, label: t('completed'), value: 1 },
                        { _id: 2, label: t('canceled'), value: 2 },
                        { _id: 3, label: t('rescheduled'), value: 3 },
                        { _id: 4, label: t('no_show'), value: 3 }
                      ]}
                      dropdownOptionBold={true}
                      getSelectedValue={(e) => setDemoCompletion(e._id)}
                    />
                </div>
              </div>   
              <div class="inline-flex items-center justify-center w-full">
                  <hr class="w-64 h-px my-8 bg-gray-200 border-0 dark:bg-gray-700"/>
                  <span class="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-gray-900">{t('second_demo')}</span>
              </div>           
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('date')}</div>
                </div>
                <div className="col-span-2">
                  <Flatpickr
                    ref={flatPicker}
                    className='w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200'
                    placeholder={t('enter_date')}
                    value={secondDemoDate}
                    options={{ 
                      dateFormat: "m/d/Y",
                      //minDate:new Date()
                    }}
                    onChange={(selectedDates, dateStr, instance) => {
                      setSecondDemoDate(dateStr)
                    }}
                  />
                </div>
              </div> 
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('notes')}</div>
                </div>
                <div className="col-span-2">
                  <Textarea
                    inputClasses={"!h-32"}
                    inputValue={secondDemoNotes}
                    setTextarea={setSecondDemoNotes}                  
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('completion')}</div>
                </div>
                <div className="col-span-2">
                    <Select
                      xPlacement={"left"}
                      selectedValue={secondDemoCompletion}
                      dropdownClass={"!w-60"}
                      dropdownButtonLabelClass={"!font-bold"}
                      dropdownData={[
                        { _id: "", label: t('select_completion'), value: "" },
                        { _id: 1, label: t('completed'), value: 1 },
                        { _id: 2, label: t('canceled'), value: 2 },
                        { _id: 3, label: t('rescheduled'), value: 3 },
                        { _id: 4, label: t('no_show'), value: 3 }
                      ]}
                      dropdownOptionBold={true}
                      getSelectedValue={(e) => setSecondDemoCompletion(e._id)}
                    />
                </div>
              </div>  
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">{t('status')}</div>
                </div>
                <div className="col-span-2">
                    <Select
                      xPlacement={"left"}
                      selectedValue={status}
                      dropdownClass={"!w-60"}
                      dropdownButtonLabelClass={"!font-bold"}
                      dropdownData={[
                        { _id: "", label: t('select_status'), value: "" },
                        { _id: 1, label: t('sale'), value: 1 },
                        { _id: 2, label: t('no_sale'), value: 2 },
                        { _id: 3, label: t('pending'), value: 3 }
                      ]}
                      dropdownOptionBold={true}
                      getSelectedValue={(e) => setStatus(e._id)}
                    />
                </div>
              </div> 
            </div>
          </div>
        </div>
        <div className="py-3 px-3 border-t border-slate-200">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonType={"button"}
              buttonIcon={
                isCancel ? "fa-light fa-spinner fa-spin" : "fa-light fa-times"
              }
              buttonIconPosition={"left"}
              buttonLabel={t('cancel')}
              buttonClasses={
                "!bg-slate-200 !text-slate-600 border border-slate-300"
              }
              functions={onCancel}
              buttonHasLink={false}
              buttonDisabled={isCancel}
            />
            <Button
              buttonType={"button"}
              buttonIcon={
                isUpdate ? "fa-light fa-spinner fa-spin" : "fa-light fa-check"
              }
              buttonIconPosition={"left"}
              buttonLabel={t('save')}
              functions={onUpdate}
              buttonHasLink={false}
              buttonDisabled={isUpdate}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadTracking;